import React from 'react';
import { Card } from 'react-bootstrap';
import ProfitFunction from './ProfitFunction';
import { useParams } from 'react-router-dom';


const CustomerProductBreakdown = (props) => {

  const { customerId } = useParams();

  return (
    <Card className="CustomerInsights" header="Customer Product Breakdown">
      <div><ProfitFunction contactName={customerId} months='2023' /></div>
      <div><ProfitFunction contactName={customerId} months='2024' /></div>
      <div><ProfitFunction contactName={customerId} months='2025' /></div>
      <div><ProfitFunction contactName={customerId} months='2026' /></div>

    </Card>
  )
}


export default CustomerProductBreakdown;
